import {defineStore} from 'pinia'
import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //选中的店铺
    selectedStoreArray: [],
    //通过openReport页加购的活动页的店铺id（即export-report.vue中的"Add to campaign"按钮）
    openReportStoreId: '',
    //总进店数量
    totalInStoreNum: 0,
    totalPrice: 0
  },
  mutations: {
    // 添加一个店铺
    addToSelectedSingleStore(state, item) {
      state.selectedStoreArray.push(item);
      localStorage.setItem('selectedStoreArray', JSON.stringify(state.selectedStoreArray));
      localStorage.setItem('selectedStoreSize', state.selectedStoreArray.length+'');

    },
    // 添加多个店铺
    addToSelectedArrayStore(state, itemArr) {
      state.selectedStoreArray.push(...itemArr);
      localStorage.setItem('selectedStoreArray', JSON.stringify(state.selectedStoreArray));
      localStorage.setItem('selectedStoreSize', state.selectedStoreArray.length+'');


    },

    clearSelectedStoreArray(state) {
      state.selectedStoreArray = [];
      localStorage.setItem('selectedStoreSize', '0');
      localStorage.setItem('selectedStoreArray', JSON.stringify(state.selectedStoreArray));

    },
    //替换数组
    replaceSelectedStoreArray(state, item) {
      state.selectedStoreArray = item;
      localStorage.setItem('selectedStoreArray', JSON.stringify(state.selectedStoreArray));
      localStorage.setItem('selectedStoreSize', state.selectedStoreArray.length+'');


    },
    addOpenReportStoreId(state, item) {
      state.openReportStoreId = item;
      localStorage.setItem('openReportStoreId', item);
    },
    setTotalInStoreNum(state, item) {
      state.totalInStoreNum = item;
      localStorage.setItem('totalInStoreNum', item);

    },
    setTotalPrice(state, item) {
      state.totalPrice = item;

    }



  },
  getters:{


  }
  // 其他Vuex属性如actions, getters, modules等
})




export const useStore = defineStore('store', {
  state: () => {
    return {
      breadCrumbList: []
    }
  },
  actions: {
    setBreadCrumbList(data) {
      this.breadCrumbList = data
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js